import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-design/images/menu-bar.png'
import _imports_1 from '@/assets/new-design/images/setting-icon.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4178385e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "kt_header",
  style: {},
  class: "header header-new"
}
const _hoisted_2 = { class: "header-inner flex-column" }
const _hoisted_3 = { class: "w-100 d-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "btn btn-icon" }
const _hoisted_5 = {
  key: 0,
  class: "svg-icon svg-icon-2x"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "fa fa-times",
  style: {"font-size":"20px","color":"#4070ea"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text",
  style: {"cursor":"pointer"}
}, "Menu", -1))
const _hoisted_10 = {
  class: "d-flex align-items-center",
  id: "kt_header_menu_nav"
}
const _hoisted_11 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainLogo = _resolveComponent("MainLogo")!
  const _component_KTTopbar = _resolveComponent("KTTopbar")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
          ref: "mainMenu",
          class: "d-flex align-items-center drawer-icon",
          title: "Show aside menu"
        }, [
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.menu)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _hoisted_7))
              : (_openBlock(), _createElementBlock("span", _hoisted_8))
          ]),
          _hoisted_9
        ], 512),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_MainLogo, { class: "header-logo" })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("img", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToSettings && _ctx.goToSettings(...args))),
            src: _imports_1,
            alt: "settings",
            class: "header-icons",
            style: {"margin-right":"20px"}
          }),
          _createVNode(_component_KTTopbar, { currentUser: _ctx.currentUser }, null, 8, ["currentUser"])
        ])
      ]),
      (_ctx.menu)
        ? (_openBlock(), _createBlock(_component_Menu, {
            key: 0,
            ref: "mainMenu",
            onClose: _ctx.closeMenu
          }, null, 8, ["onClose"]))
        : _createCommentVNode("", true)
    ])
  ]))
}